import { create } from "zustand";
import { SubmissionState } from "./types";

/**
 * Submission store for managing form submissions
 * This store is not persisted as it's temporary state
 */
const useSubmissionStore = create<SubmissionState>()((set) => ({
  submissions: [],
  setSubmissions: (submissions) => set({ submissions }),
  resetSubmissions: () => set({ submissions: [] }),
}));

export default useSubmissionStore;
